import React, { useContext, useEffect, useState } from 'react'
import { AuthContext } from '../../contexts/authContext'
import AuthHeaderLogged from './AuthHeaderLogged'
import AuthHeaderLogin from './AuthHeaderLogin'
import { Link as GatsbyLink } from 'gatsby'
import SideMenuMobile from '../SideMenu/SideMenuMobile'
import Search from '../Search'
import styles from './styles.module.css'

function AuthHeader() {
  let toolTabIndex = 0
  const getNextTabIndex = () => (toolTabIndex += 1)

  const [profile, setProfile] = useState()
  const { user } = useContext(AuthContext)

  useEffect(() => {
    if (user && user.profile) {
      setProfile(user.profile)
    }
  }, [user])

  return (
    <hot-header slot="header">
      <GatsbyLink to="/" className="logo-link" slot="logo-link">
        Hotmart
      </GatsbyLink>
      <span slot="brand-name">Developers</span>

      <div slot="header-actions" className={`_flex-1 _mx-auto ${styles.headerSearch}`}>
        <Search />
      </div>

      <div slot="header-actions" className="_mr-2">
        <SideMenuMobile tabIndex={getNextTabIndex()} />
        {profile ? <AuthHeaderLogged tabIndex={getNextTabIndex()} /> : <AuthHeaderLogin tabIndex={getNextTabIndex()} />}
      </div>
    </hot-header>
  )
}

export default AuthHeader
